// core version + navigation, pagination modules:
import Swiper, { Pagination, Autoplay, EffectFade } from 'swiper';
// import Swiper and modules styles
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';


export default function(){
	// init Swiper:
	const swiperBanner = new Swiper('.swiper-banner', {

		modules: [Pagination, Autoplay, EffectFade],
		loop: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		// autoplay: {
		//     delay: 4000,
		// },
		speed: 1000,
	});




	var init = false;

	function swiperWhatsOn() {
		if (window.innerWidth >= 768) {
			if ( ! init ) {
				init = true;

				const swiper = new Swiper('.swiper-whats-on', {

					modules: [Pagination, Autoplay, EffectFade],
					loop: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					},
					slidesPerView: 1,
					slidesPerGroup: 1,
					slidesPerColumn: 1,
					spaceBetween: 0,
					speed: 1000,
					breakpoints: {
						// md
						728: {
							slidesPerView: 2,
							slidesPerGroup: 2,
							slidesPerColumn: 1,
							spaceBetween: 25,
							spaceBetween: 20,
						},
						// lg
						984: {
							slidesPerView: 4,
							slidesPerGroup: 4,
							slidesPerColumn: 1,
							spaceBetween: 30,
							spaceBetween: 20,
						}
					},
				});
			}
		} else if ( init ) {
			swiper.destroy();

			init = false;
		}
	}
	swiperWhatsOn();
	window.addEventListener("resize", swiperWhatsOn);

}